module.exports = __webpack_public_path__ + "static/img/SNK.0f349031.png";